"use strict";
window._theme = window._theme || {};

_theme.PageBlog = (function(){
    let triggered = false, cached_data = {};
    function init(){
        initSlider();
        jQuery('.post-featured-item-wrap .slick-dots button').attr("role","button")

        jQuery(document).on('click','#more',function(e){
          e.preventDefault();
          ScrollExecute()
        });

        const blogHandle = jQuery('.blog-template-default').data('handle');
        if(!blogHandle) return;
        jQuery('.topics-gr .topic-item').on('click',function(){
          let $this = jQuery(this);
          let val = jQuery(this).data('handle');
          if(!val) return;
          const $tabStatus = jQuery('#blog-tabs-status');
          jQuery(this).attr('aria-selected', true).siblings().attr('aria-selected', false);
          const cache_key = _theme.Helpers.handleize(val);
          jQuery(this).toggleClass('active').siblings().removeClass('active');
          if(cached_data[cache_key]){
            _theme.toggleLoading(1);
            showResult(cached_data[cache_key].html);
          } else {
            if($tabStatus.length){
              setTimeout(function(){
                $tabStatus.text('Fetching '+ val +' Content');
              }, 250);
            }
            let url = '/blogs/' + blogHandle;
            if($this.hasClass('active')){
              url = '/blogs/'+blogHandle+'/tagged/'+val+'';
            }
  
            jQuery.ajax({
              url: url,
              type: 'GET',
              beforeSend: function() {
                _theme.toggleLoading(1);
              }
            })
            .done(function(data) {
              const data_html = jQuery(data).find('.blog-default').html();
              cached_data[cache_key]= { html: data_html};
              showResult(data_html);
            });
          }

          function showResult(res_html){
            jQuery('.blog-default').html(res_html);
            _theme.toggleLoading();
            if($tabStatus.length){
              setTimeout(function(){
                $tabStatus.text('Content Loaded');
              }, 250);
            }
          }
          _theme.focusMove(jQuery('.blog-default'));
        });
    }

    function ScrollExecute() {
      let moreButon = jQuery('#more').last();
      let nextUrl = jQuery(moreButon).find('a').attr("href");
      if (((jQuery(moreButon).offset().top - jQuery(window).scrollTop()) < 800) && (triggered == false)) {
        triggered = true;
        jQuery.ajax({
          url: nextUrl,
          type: 'GET',
          beforeSend: function() {
            _theme.toggleLoading(1);
            moreButon.remove();
          }
        })
        .done(function(data) {
          _theme.toggleLoading();
          jQuery('.more-wrapper').remove();
          jQuery('.blog-default').append(jQuery(data).find('.blog-default').html());
          triggered = false
        });
      }
    }

    function initSlider(){
      if(jQuery(window).width() < 768){
        // jQuery('.post-featured-item-wrap').slick({
        //   dots: true,
        //   arrows: false,
        //   slidesToShow: 2,
        //   slidesToScroll: 2,
        // });

        const sliderSettings = {
          dots: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2,
        };
    
        initBrandSlider(false);
        
        function initBrandSlider(autoplay){
          if(autoplay){
            sliderSettings.autoplay = autoplay;
            sliderSettings.autoplaySpeed = 1000;
            sliderSettings.speed = 2000;
          }
          if(jQuery('.post-featured-item-wrap').hasClass('slick-initialized')){
            jQuery('.post-featured-item-wrap').slick('unslick');
          }
          
          jQuery('.post-featured-item-wrap').on('init beforeChange afterChange', function(event, slick, currentSlide, nextSlide){
            // slick.$slider.find('ul.slick-dots').attr('role', 'group');
            slick.$slider.find('ul.slick-dots li button').attr('role', 'tab');
            slick.$slider.find('ul.slick-dots li button').removeAttr('tabindex');
            setTimeout(function() {
              // slick.$slider.find('ul.slick-dots').attr('role', 'group');
              slick.$slider.find('ul.slick-dots li button').attr('role', 'tab');
              slick.$slider.find('ul.slick-dots li button').removeAttr('tabindex');
            },1000);
          });

          jQuery('.post-featured-item-wrap').slick(sliderSettings);
        }
      }
        
    }

    return {init: init}
})();

jQuery(function(){
    _theme.PageBlog.init();
});